module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/erasure-388d27e813a094b7dae18306cabb41c3.svg";